var moduleMap = {
	"./bootstrap": function() {
		return __webpack_require__.e("src_eager-loader_jsx-_48bd1").then(function() { return function() { return (__webpack_require__(93256)); }; });
	},
	"./code-rule": function() {
		return Promise.all([__webpack_require__.e("vendors-node_modules_axios_index_js"), __webpack_require__.e("vendors-node_modules_aws-sdk_util-locate-window_dist-es_index_js-node_modules_bowser_es5_js"), __webpack_require__.e("vendors-node_modules_aws-sdk_client-chime-sdk-meetings_dist-es_ChimeSDKMeetingsClient_js-node-b87bd4"), __webpack_require__.e("vendors-node_modules_react-icons_all-files_ai_AiOutlineArrowDown_js-node_modules_react-icons_-4db0be"), __webpack_require__.e("vendors-node_modules_jsoneditor-react_es_editor_min_css-node_modules_rjsf_bootstrap-4_dist_bo-210492"), __webpack_require__.e("src_api_ChimeAPI_ts"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_views_CodeRules_index_tsx"), __webpack_require__.e("src_Config_js-src_api_SNOMED_ts-src_api_emisTypes_ts-src_components_CodeRule_index_tsx-node_m-8e1ee1")]).then(function() { return function() { return (__webpack_require__(84677)); }; });
	},
	"./chime-api": function() {
		return Promise.all([__webpack_require__.e("vendors-node_modules_axios_index_js"), __webpack_require__.e("vendors-node_modules_aws-sdk_util-locate-window_dist-es_index_js-node_modules_bowser_es5_js"), __webpack_require__.e("vendors-node_modules_aws-sdk_client-chime-sdk-meetings_dist-es_ChimeSDKMeetingsClient_js-node-b87bd4"), __webpack_require__.e("src_api_ChimeAPI_ts"), __webpack_require__.e("src_Config_js-node_modules_jwt-decode_build_jwt-decode_esm_js")]).then(function() { return function() { return (__webpack_require__(19683)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});